var React = require('react');

function IconNoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 6.177c5.457 0 12.93-.277 18.297-.138 7.199.184 9.904 3.317 9.996 11.056.091 4.375 0 16.905 0 16.905h-7.79c0-10.963.047-12.772 0-16.227-.09-3.04-.96-4.489-3.298-4.766-2.476-.276-9.416-.046-9.416-.046V34H6V6.177z"}));
}

IconNoteInline.defaultProps = {"width":"40","height":"40"};

module.exports = IconNoteInline;

IconNoteInline.default = IconNoteInline;
